function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleStaffFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54 21.242c-.876.807-1.533 1.925-1.698 3.188a.922.922 0 01-.003.018L5.16 28h21.68l-.679-3.552a1.226 1.226 0 01-.004-.034c-.144-1.25-.794-2.363-1.676-3.17-.893-.817-1.937-1.244-2.78-1.244a1 1 0 110-2c1.455 0 2.961.698 4.13 1.768 1.178 1.078 2.1 2.608 2.31 4.4l.848 4.684A1 1 0 0128 30H4a1 1 0 01-.99-1.148l.85-4.691c.236-1.784 1.154-3.312 2.325-4.39C7.348 18.7 8.842 18 10.3 18a1 1 0 110 2c-.841 0-1.872.425-2.76 1.242z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 25.5H21c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h3.5c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5zM14.3 19.4a1 1 0 10-1.6 1.2l1.237 1.65L12.5 30h2l1.347-7h.306l1.347 7h2l-1.437-7.75L19.3 20.6a1 1 0 00-1.6-1.2L16.5 21h-1l-1.2-1.6z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4a2 2 0 012-2h8a2 2 0 012 2v3a1 1 0 01-.05.312 7 7 0 11-11.901 0A1 1 0 0110 7V4zm2 0h8v2h-8V4zm0 4a5 5 0 108 0h-8z",
    fill: props.color
  }));
}

export default SvgIconPeopleStaffFilled;